import {DomainEvent} from './DomainEvent';
import {News} from '../resources/News';

export class NewsImageUpdated extends DomainEvent<News> {}
